<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/account.svg" alt="Cuentas" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Cuentas</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{getDropdownText()}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todas las cuentas
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Cuentas recientemente mostradas
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'ancladas'" (click)="selectItem('ancladas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'ancladas'">✔</span>
                                        Visto recientemente (lista anclada)
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'mis'" (click)="selectItem('mis')">
                                        <span class="check-icon" *ngIf="selectedItem === 'mis'">✔</span>
                                        Mis cuentas
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn primary" (click)="openMdlCreateAccount()">
                            <img src="assets/svg/plus-icon.svg" alt="Añadir nuevo" width="16" height="16" />
                            Añadir nuevo
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{cuentasFiltradas.length}} elementos | Se actualizó hace 2 minutos</span>
                    <!-- Mostrar filtros activos -->
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>

                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="!isLoading && cuentas.length > 0">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar por nombre de cuenta, teléfono o propietario..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarCuentas()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                                <button class="d-grid search-btn" (click)="openMdlCharts()">
                                    <img src="assets/svg/grafic-icon.svg" alt="Gráfica">
                                    <span>Ver gráfico</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>
                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th 
                                            (click)="sortByColumn('nombre_empresa')"
                                            [class.sorted]="sortColumn === 'nombre_empresa'"
                                            class="sortable-header"
                                        >
                                            Nombre de la cuenta
                                            <span *ngIf="sortColumn === 'nombre_empresa'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('telefono')"
                                            [class.sorted]="sortColumn === 'telefono'"
                                            class="sortable-header"
                                        >
                                            Teléfono
                                            <span *ngIf="sortColumn === 'telefono'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('ejecutivo.nombre')"
                                            [class.sorted]="sortColumn === 'ejecutivo.nombre'"
                                            class="sortable-header"
                                        >
                                            Propietario
                                            <span *ngIf="sortColumn === 'ejecutivo.nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let cuenta of cuentasFiltradas; let i=index" (click)="verDetalleCuenta(cuenta.id, $event)">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td>{{cuenta.nombre_empresa.charAt(0).toUpperCase() + cuenta.nombre_empresa.slice(1)}}</td>
                                        <td>{{cuenta.telefono.charAt(0).toUpperCase() + cuenta.telefono.slice(1)}}</td>
                                        <td>{{cuenta?.ejecutivo.nombre.charAt(0)}}{{cuenta?.ejecutivo.apellido.split(' ')[0]}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + cuenta.id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + cuenta.id">
                                                    <button class="dropdown-item" (click)="updateAccount(cuenta)">Modificar</button>
                                                    <button class="dropdown-item" (click)="openMdlDeleteAccount(cuenta.id)">Eliminar</button>
                                                    <button class="dropdown-item">Cambiar propietario</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="!isLoading && cuentas.length === 0 && !errorMessage" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                <img src="assets/img/listaprospecto.png" alt="Lista de prospectos vacía" />
                            </div>
                            <h2>Sin cuentas por ahora</h2>
                            <p>Todavía no tienes cuentas registradas. Puedes comenzar agregando una nueva.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>